import { useEffect } from 'react';
import {
  Box,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import DeviceAnalyticsTable from 'pages/admin/sections/DeviceAnalyticsTable';
import { fetchDeviceAnalytics } from 'store/actions/adminActions';

const VERSION_PARAM = 'version';

const DeviceAnalyticsHome = () => {
  const dispatch = useDispatch();
  const { deviceAnalytics, versions } = useSelector((state: any) => state.admin);
  const [searchParams, setSearchParams] = useSearchParams();
  const version = searchParams.get(VERSION_PARAM) ?? '';

  useEffect(() => {
    dispatch({
      type: fetchDeviceAnalytics.request,
      payload: version ? { version } : {},
    });
  }, [dispatch, version]);

  const handleVersionChange = (value: string) => {
    if (value) {
      setSearchParams({ [VERSION_PARAM]: value });
    } else {
      setSearchParams({});
    }
  };

  return (
    <Box
      component='main'
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth='lg'>
        <Stack spacing={3}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={3}
            alignItems={{ xs: 'stretch', sm: 'center' }}
          >
            <Stack spacing={1} sx={{ flex: '1 1 auto' }}>
              <Typography variant='h4'>Device Analytics</Typography>
            </Stack>
            <FormControl size='small' sx={{ width: { xs: '100%', sm: 200 } }}>
              <InputLabel id='version-filter-label'>Version</InputLabel>
              <Select
                labelId='version-filter-label'
                label='Version'
                value={versions.includes(version) ? version : ''}
                onChange={(event) => handleVersionChange(event.target.value)}
              >
                <MenuItem value=''>All versions</MenuItem>
                {versions.map((item: string) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <DeviceAnalyticsTable rows={deviceAnalytics} />
        </Stack>
      </Container>
    </Box>
  );
};

export default DeviceAnalyticsHome;
